module.exports = __webpack_public_path__ + "static/media/bg.f8b22d14.jpg";